import {getSignificanceBasedPrecision, human} from '@github-ui/formatters'
import type {ListResults, RepositoryItem, UserInfo} from '@github-ui/repos-list-shared'

import {getSortFromQuery} from '../utils/query'
import {getSortingKeyAndDirection, getSortingOptionLabel, type OrderOptions} from './sorting-options'

export function getScreenReaderMessage(
  sortingOptions: Record<string, OrderOptions>,
  defaultSortingKey: string,
  getEmptyMessage: (params: {filtered: boolean; currentPage: number; pageCount: number; userInfo?: UserInfo}) => string,
  isFetching: boolean,
  currentPage: number,
  query: string,
  results: ListResults<RepositoryItem>,
  userInfo?: UserInfo,
): string {
  if (isFetching) return ''

  const {repositories, repositoryCount, pageCount} = results
  if (repositories.length === 0) {
    return getEmptyMessage({filtered: !!query, currentPage, pageCount, userInfo})
  }

  const [sortKey, direction] = getSortingKeyAndDirection(getSortFromQuery(query), defaultSortingKey)
  const sortingLabel = getSortingOptionLabel(sortKey, sortingOptions)
  const sortOrder = direction === 'asc' ? 'ascending' : 'descending'
  return `${getDisplayReposCount(repositoryCount)} found. List is sorted by ${sortingLabel} in ${sortOrder} order.`
}

export function getDisplayReposCount(count: number): string {
  const displayCount = human(count, {
    precision: getSignificanceBasedPrecision(count),
  })
  return `${displayCount} ${count === 1 ? 'repository' : 'repositories'}`
}
